/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';

import { BuilderEstimatingRoutingModule } from './builder-estimating-routing.module';
import { BulkDeleteHpBusinessService, BulkDeleteHpComponent } from './bulk-delete-hp';
import {
  BulkUpdateBusinessService,
  BulkUpdateComponentAddComponent,
  BulkUpdateComponentDeleteComponent,
  BulkUpdateComponentReplaceComponent,
  BulkUpdateContainerComponent,
  BulkUpdateHpAddComponent,
  BulkUpdateHpDeleteComponent,
  BulkUpdateHpReplaceComponent,
} from './bulk-update';
import {
  FormulaPropagationBusinessService,
  FormulaPropagationDialogComponent,
  FormulaPropagationHpListDialogComponent,
  HousePlanDetailsDialogComponent,
  HousePlanEstimateCreateDialogComponent,
  HousePlanEstimateDetailsBusinessService,
  HousePlanEstimateDetailsComponent,
  HousePlanListBusinessService,
  HousePlanListComponent,
  HpeDetailsCcItemComponentComponent,
  HpeDetailsCcItemDetailsComponent,
  HpeDetailsCcItemListComponent,
  HpeDetailsCcListComponent,
  HpeDetailsCcParentComponent,
  HpeDetailsComponentDetailsComponent,
  HpeDetailsComponentListComponent,
  HpeDetailsComponentsParentComponent,
  HpeDetailsCuttingListComponent,
  HpeDetailsTopListComponent,
  HpeOrderDetailsDialogComponent,
  HpeTopUsageDialogComponent,
} from './house-plans';
import {
  PBDetailsCcListComponent,
  PbDetailsDefaultsFormComponent,
  PbDetailsHpFormComponent,
  PbDetailsHpListComponent,
  PbDetailsStructureListComponent,
  PbDetailsTopFormComponent,
  PbItemsComponentsComponent,
  PriceBookDetailsBusinessService,
  PriceBookDetailsComponent,
  PriceBookLinkBusinessService,
  PriceBookLinkComponent,
  PriceBookListBusinessService,
  PriceBookListComponent,
  PriceBookBulkUpdateICComponent,
  PriceBookBulkUpdateHPComponent,
} from './price-books';
import { JobEstimatesJobListBusinessService } from './job-estimates-job-list/resources/job-estimates-job-list-business.service';
import { JobEstimatesJobListComponent } from './job-estimates-job-list/job-estimates-job-list.component';

@NgModule({
  imports: [
    CoreUiExtSplitPaneModule,
    BuilderSharedModule.forChild(),
    BuilderEstimatingRoutingModule,
  ],
  providers: [
    HousePlanListBusinessService,
    HousePlanEstimateDetailsBusinessService,
    PriceBookListBusinessService,
    PriceBookDetailsBusinessService,
    PriceBookLinkBusinessService,
    BulkUpdateBusinessService,
    FormulaPropagationBusinessService,
    BulkDeleteHpBusinessService,
    JobEstimatesJobListBusinessService,
  ],
  declarations: [
    HousePlanListComponent,
    HousePlanDetailsDialogComponent,
    HousePlanEstimateDetailsComponent,
    HpeDetailsCcListComponent,
    HpeDetailsTopListComponent,
    HpeDetailsComponentsParentComponent,
    HpeDetailsComponentListComponent,
    HpeDetailsComponentDetailsComponent,
    HpeDetailsCuttingListComponent,
    HpeDetailsCcParentComponent,
    HpeDetailsCcItemListComponent,
    HpeDetailsCcItemDetailsComponent,
    HpeDetailsCcItemComponentComponent,
    HpeTopUsageDialogComponent,
    HpeOrderDetailsDialogComponent,
    HousePlanEstimateCreateDialogComponent,
    PriceBookListComponent,
    PriceBookDetailsComponent,
    PriceBookLinkComponent,
    PriceBookBulkUpdateHPComponent,
    PriceBookBulkUpdateICComponent,
    PbDetailsTopFormComponent,
    PbDetailsDefaultsFormComponent,
    PbItemsComponentsComponent,
    PBDetailsCcListComponent,
    PbDetailsStructureListComponent,
    PbDetailsHpListComponent,
    PbDetailsHpFormComponent,
    BulkUpdateContainerComponent,
    BulkUpdateHpAddComponent,
    BulkUpdateComponentAddComponent,
    BulkUpdateHpReplaceComponent,
    BulkUpdateComponentReplaceComponent,
    BulkUpdateHpDeleteComponent,
    BulkUpdateComponentDeleteComponent,
    FormulaPropagationDialogComponent,
    FormulaPropagationHpListDialogComponent,
    BulkDeleteHpComponent,
    JobEstimatesJobListComponent,
  ],
  entryComponents: [
    HousePlanDetailsDialogComponent,
    HousePlanEstimateCreateDialogComponent,
    HpeTopUsageDialogComponent,
    HpeOrderDetailsDialogComponent,
    FormulaPropagationDialogComponent,
    FormulaPropagationHpListDialogComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderEstimatingModule {
}
